module.exports = __webpack_public_path__ + "assets/d0805e23b89d959caea1ddfb6447db7d.mp3";